import styled from 'styled-components';
import { TrimSelectStyled } from '../TrimSelectStyled';
import { rem } from 'polished';

export const TrimSelectStyledAP = styled(TrimSelectStyled)`
    .isSelected {
        background: ${({ theme }) => theme.colors.primaryLight};
    }
`;
